import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import fr from './fr.json';
//TODO: Fix this
// import es from './es.json';
// import it from './it.json';

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: {
            en: en,
            fr: fr,
            // es: es,
            // it: it,
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });
